"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extrinsicsByArgs = exports.extrinsicByHash = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const common_1 = require("./common");
const types_1 = require("../types");
/**
 * @hidden
 *
 * Get a transaction by hash
 */
function extrinsicByHash(variables) {
    const query = (0, graphql_tag_1.default) `
    query TransactionByHashQuery($extrinsicHash: String!) {
      extrinsics(filter: { extrinsicHash: { equalTo: $extrinsicHash } }) {
        nodes {
          extrinsicIdx
          address
          nonce
          moduleId
          callId
          paramsTxt
          success
          specVersionId
          extrinsicHash
          block {
            blockId
            hash
            datetime
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.extrinsicByHash = extrinsicByHash;
/**
 * @hidden
 *
 * Get transactions
 */
function extrinsicsByArgs(isSqIdPadded, filters, size, start, orderBy = types_1.ExtrinsicsOrderBy.BlockIdAsc) {
    const { args, filter } = (0, common_1.createArgsAndFilters)(filters, {
        moduleId: 'ModuleIdEnum',
        callId: 'CallIdEnum',
        success: 'Int',
    });
    if (isSqIdPadded) {
        if (orderBy === types_1.ExtrinsicsOrderBy.CreatedAtAsc) {
            orderBy = types_1.ExtrinsicsOrderBy.BlockIdAsc;
        }
        if (orderBy === types_1.ExtrinsicsOrderBy.CreatedAtDesc) {
            orderBy = types_1.ExtrinsicsOrderBy.BlockIdDesc;
        }
    }
    const query = (0, graphql_tag_1.default) `
    query TransactionsQuery
      ${args}
     {
      extrinsics(
        ${filter}
        orderBy: [${orderBy}]
        first: $size
        offset: $start
      ) {
        totalCount
        nodes {
          blockId
          extrinsicIdx
          address
          nonce
          moduleId
          callId
          paramsTxt
          success
          specVersionId
          extrinsicHash
          block {
            hash
            datetime
          }
        }
      }
    }
  `;
    return {
        query,
        variables: (0, common_1.removeUndefinedValues)(Object.assign(Object.assign({}, filters), (0, common_1.getSizeAndOffset)(size, start))),
    };
}
exports.extrinsicsByArgs = extrinsicsByArgs;
//# sourceMappingURL=extrinsics.js.map